import {createStrokeSVG} from './TEMPLATE'

// iconoir: globe
export const Earth_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z',
    'M2.5 12.5L8 14.5L7 18L8 21',
    'M17 20.5L16.5 18L14 17V13.5L17 12.5L21.5 13',
    'M19 5.5L18.5 7L15 7.5V10.5L17.5 9.5H19.5L21.5 10.5',
    'M2.5 10.5L5 8.5L7.5 8L9.5 5L8.5 3',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 1.5,
})

// iconoir: globe
export const Earth_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z',
    'M2.5 12.5L8 14.5L7 18L8 21',
    'M17 20.5L16.5 18L14 17V13.5L17 12.5L21.5 13',
    'M19 5.5L18.5 7L15 7.5V10.5L17.5 9.5H19.5L21.5 10.5',
    'M2.5 10.5L5 8.5L7.5 8L9.5 5L8.5 3',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 1.5,
})

// tabler: world
export const Globe_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0',
    'M3.6 9h16.8',
    'M3.6 15h16.8',
    'M11.5 3a17 17 0 0 0 0 18',
    'M12.5 3a17 17 0 0 1 0 18',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
